module.exports = function () {
  return "\n    <div class=\"vp-overlay\">\n    </div>\n  ";
};